module.exports = __webpack_public_path__ + "static/media/eminence-ikebukuro-5.1859da8d.jpg";